import styled from 'styled-components'

export const RecordSelectWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: var(--color-white);
    border-radius: 8px;
    overflow: hidden;
`

export const RecordSelector = styled.div`
    width: 100%;
    flex: 1;
    padding: 12px;
`

export const Relation = styled.button<{ isWrap: boolean }>`
    white-space: ${({ isWrap }) => (isWrap ? 'normal' : 'nowrap')};
    word-break: break-word;
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: row;
    text-align: left;
    justify-content: space-between;
    padding: 5px 8px;
`
export const TagContain = styled.div`
    display: flex;
    width: calc(100% - 24px);
    height: 100%;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    /* overflow: hidden; */
`
